module.exports = __webpack_public_path__ + "static/img/32.12c61e3a.jpeg";